import CrossCircleIcon from '@atlaskit/icon/core/cross-circle';
import {
  DatabaseTraceAction,
  DatabaseTraceSource,
  traceDatabaseAction
} from '@databases/frontend-metrics/perf-tracing';
import { messages } from '@databases/intl/messages';
import { SHORTCUTS, tooltip } from '@databases/keyboard-shortcuts';
import React from 'react';

import { SELECT_VALUE_MENU_ACTIONS } from '../../../select-value-menu/types.ts';
import { type SelectionsEffectMenuItemBuilder } from '../types.ts';

export const clearValuesMenuItem: SelectionsEffectMenuItemBuilder = (
  context,
  actions,
  skip
) => {
  if (!context.capabilities.canClearContent) {
    return skip;
  }

  return () => ({
    key: SELECT_VALUE_MENU_ACTIONS.CLEAR_VALUES,
    content: context.formatMessage(messages['value-actions.clear-cells'], {
      valuesCount: '1'
    }),
    onMouseEnter: () => {
      context.selectionsActions.clearSelectionIntent();
    },
    onClick: () => {
      traceDatabaseAction(
        { action: DatabaseTraceAction.ValueClear, source: DatabaseTraceSource.ValueMenu },
        () => {
          actions.cell.handleClearFields();
        }
      );

      context.closeMenu();
    },
    elemAfter: <>{tooltip(SHORTCUTS.CLEAR.keyMap)}</>,
    elemBefore: <CrossCircleIcon label="" />
  });
};
